"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TRACKIFY_SYNERISE = exports.TRACKIFY_USERCOM = exports.TRACKIFY_GTM = exports.TRACKIFY_DEBUG = void 0;
exports.TRACKIFY_DEBUG = Symbol.for('TRACKIFY_DEBUG');
exports.TRACKIFY_GTM = Symbol.for('TRACKIFY_GTM');
exports.TRACKIFY_USERCOM = Symbol.for('TRACKIFY_USERCOM');
exports.TRACKIFY_SYNERISE = Symbol.for('TRACKIFY_SYNERISE');
//# sourceMappingURL=tokens.js.map